import React, {Component} from "react";

import "./PictureGallery.css";
import Picture from "./Picture";

class PictureGallery extends Component {

  render() {
    const {pictures, displayMissing, ...rest} = this.props;

    const gallery = [];
    if (pictures){
        pictures.forEach(picture =>
          gallery.push(
            <li key={picture.key} className="photos-gallery__item">
              <Picture picture={picture} {...rest}/>
            </li>)
        );
      }
      if (displayMissing && gallery.length < displayMissing){
        do {
          gallery.push(
            <li className="photos-gallery__item photos-gallery__missing">
              <span className="sr-only">Photo is missing, only ${pictures.length || 0} of ${displayMissing}</span>
              <svg className="photos-gallery__missing-icon">
                <use xlinkHref="#icon-warning"></use>
              </svg>
            </li>
          )
        } while (gallery.length < displayMissing);

      }

    return (
      <ul className="photos-gallery">
        {gallery}
      </ul>
    );
  }
}

export default PictureGallery;



// WEBPACK FOOTER //
// ./src/components/interventiondetail/picture/PictureGallery.js